import { DatePipe } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { sortBy } from 'lodash';
import { TranslatePipe } from '@ngx-translate/core';
import type { ICountry } from '../../../../../shared/interfaces/ICountry';

@Component({
    selector: 'app-tab-country-info',
    templateUrl: './tab-country-info.component.html',
    styleUrls: ['./tab-country-info.component.scss'],
    imports: [TranslatePipe, DatePipe]
})
export class TabCountryInfoComponent {
    public readonly country = input<ICountry | null>(null);
    public readonly holidays = computed(() => sortBy(this.country()?.holidays ?? [], 'date'));
}
